// extracted by mini-css-extract-plugin
module.exports = {"ctaToastBox":"CtaToast_ctaToastBox__zSt79","ctaContent":"CtaToast_ctaContent__m8tp0","slogan":"CtaToast_slogan__tG_2w"};